import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Capacitor } from '@capacitor/core';
import { App } from './App';
import { queryClient } from './api/queryClient';
import { prefetchStartupQueries } from './api/prefetch';
import { handlePreloadError } from './lib/preloadError';
import './i18n';
import './styles.css';

// Not in Capacitor native shells: assets there are served from disk already,
// and WKWebView service workers are unreliable.
// MODE, not PROD: the root .env sets NODE_ENV=development (for the API),
// which envDir feeds into Vite and flips PROD to false even in `vite build`
// — the whole block would be tree-shaken out of the production bundle.
if (
  import.meta.env.MODE === 'production' &&
  'serviceWorker' in navigator &&
  window.isSecureContext &&
  !Capacitor.isNativePlatform()
) {
  // updateViaCache: 'none' — the HTTP cache must never delay an sw.js fix.
  void navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });
}

// A deploy swaps dist/ atomically, so an open tab's not-yet-loaded lazy chunk
// can 404 (old hashed name is gone). Reload picks up the new index.html.
window.addEventListener('vite:preloadError', handlePreloadError);

// Warm up the first screen's queries while React is still parsing/mounting —
// saves 1–3 sequential round-trips on a cold PWA start.
prefetchStartupQueries();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
